import { Inject, Injectable, OnDestroy, Optional } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Observable, ReplaySubject, Subscription, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DashboardResponse } from '../models/dashboard.interfaces';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UserService implements OnDestroy {
  data$: Observable<DashboardResponse>;

  private _dashboardData$: ReplaySubject<DashboardResponse> =
    new ReplaySubject<DashboardResponse>();

  private _subscription: Subscription = new Subscription();

  constructor(
    @Optional() @Inject('REDIRECT') protected _overrideRedirect: boolean,
    @Optional() @Inject('ACCESSIBLE') protected _accessible: boolean,
    private data: DataService,
    private log: LoggingService
  ) {
    this.data$ = this._dashboardData$.asObservable();
    if (!(_overrideRedirect === false) || _accessible) {
      this._getDashboardContent();
    }
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  private _getDashboardContent() {
    this._subscription = this.data
      .getContent()
      .pipe(
        tap((response) => {
          if (response.loggedIn ? response.loggedIn : false) {
            this._dashboardData$.next(response);
            this.log.addMetadata(
              'SkyMiles',
              response.smNumber || 'no-number-defined'
            );
          } else {
            this._dashboardData$.error(new Error('The user is not logged in'));
          }
        }),
        catchError((error) => {
          this._dashboardData$.error(new Error(error));
          return throwError(error);
        })
      )
      .subscribe();
  }
}
